module.exports = __webpack_public_path__ + "img/status_failed_black-01.d9b76438.png";